import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatMoney } from 'accounting';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faList from '@fortawesome/fontawesome-free-solid/faList';
import faChartLine from '@fortawesome/fontawesome-free-solid/faChartLine';
import faMoneyBill from '@fortawesome/fontawesome-free-solid/faMoneyBill';
import faDollarSign from '@fortawesome/fontawesome-free-solid/faDollarSign';
import faCircle from '@fortawesome/fontawesome-free-regular/faCircle';

import {
  getSummaryPieChartData,
  getItemCountChartData,
  getCollectionTimelineChartData,
  getDashboardStats,
} from '../../../redux/selectors/transactions';
import Loading from '../../common/Loading';
import pageWrapper from '../../containers/MainPage';
import { fetchFinances, fetchTransactions } from '../../../redux/ducks/transactions';
import DashboardPieChart from './DashboardPieChart';
import DashboardTimelineChart from './DashboardTimelineChart';
import StatItem from './StatItem';
import './DashboardPage.css';

class DashboardPage extends React.Component {
  componentDidMount() {
    const { fetched, getData } = this.props;

    if (!fetched) {
      getData();
    }
  }

  render() {
    const {
      isFetching,
      fetched,
      marketValueChartData,
      itemCountChartData,
      timelineChartData,
      statsData,
    } = this.props;

    if (isFetching || !fetched) {
      return <Loading />;
    }

    const countTooltip = ({ label, value, percentage }) => (
      <span>
        {label}
        <br />
        {value} items<br />
        {percentage} %
      </span>
    );

    const valueTooltip = ({ label, value, percentage }) => (
      <span>
        {label}
        <br />
        {formatMoney(value, '$', 0)}
        <br />
        {percentage} %
      </span>
    );

    return (
      <div className="dashboard">
        <div className="dashboard-countChart box">
          <h3 className="subtitle is-4 has-text-centered">Item Count</h3>
          <DashboardPieChart data={itemCountChartData} tooltipTextFn={countTooltip} />
        </div>
        <div className="dashboard-valueChart box">
          <h3 className="subtitle is-4 has-text-centered">Market Value</h3>
          <DashboardPieChart data={marketValueChartData} tooltipTextFn={valueTooltip} />
        </div>
        <div className="dashboard-stats box">
          <h3 className="subtitle is-4">Totals</h3>
          <StatItem
            label="Items"
            value={statsData.totalItemCount.toString()}
            icon={<FontAwesomeIcon icon={faList} color="#25C0E6" fixedWidth />}
          />
          <StatItem
            label="Market Value"
            value={formatMoney(statsData.marketValue, '$', 0)}
            icon={<FontAwesomeIcon icon={faChartLine} color="#25C0E6" fixedWidth />}
          />
          <StatItem
            label="Gain/Loss"
            value={formatMoney(statsData.gainLoss, '$', 0)}
            icon={<FontAwesomeIcon icon={faMoneyBill} color="#25C0E6" fixedWidth />}
          />
          <StatItem
            label="Total Purchase Price"
            value={formatMoney(statsData.totalPurchasePrice, '$', 0)}
            icon={
              <span className="fa-layers fa-fw">
                <FontAwesomeIcon icon={faCircle} color="#25C0E6" fixedWidth />
                <FontAwesomeIcon
                  icon={faDollarSign}
                  color="#25C0E6"
                  fixedWidth
                  transform="shrink-6"
                />
              </span>
            }
          />
        </div>
        <div className="dashboard-timeline box">
          <h3 className="subtitle is-4">Collection Value Timeline</h3>
          <DashboardTimelineChart data={timelineChartData} />
        </div>
      </div>
    );
  }
}

DashboardPage.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  itemCountChartData: PropTypes.array.isRequired,
  marketValueChartData: PropTypes.array.isRequired,
  timelineChartData: PropTypes.object.isRequired,
  statsData: PropTypes.object.isRequired,
  /* eslint-enable */
  isFetching: PropTypes.bool.isRequired,
  fetched: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.bool]),
  getData: PropTypes.func.isRequired,
};

DashboardPage.defaultProps = {
  fetched: false,
};

function mapStateToProps(state) {
  const marketValueChartData = getSummaryPieChartData(state);
  const itemCountChartData = getItemCountChartData(state);
  const timelineChartData = getCollectionTimelineChartData(state);
  const statsData = getDashboardStats(state);

  const {
    transactions: { isFetching, fetched },
  } = state;

  return {
    marketValueChartData,
    itemCountChartData,
    timelineChartData,
    statsData,
    isFetching,
    fetched,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getData: () => {
      dispatch(fetchTransactions());
      dispatch(fetchFinances());
    },
  };
}

export default pageWrapper(
  connect(mapStateToProps, mapDispatchToProps)(DashboardPage),
  'Dashboard'
);



// WEBPACK FOOTER //
// ./src/components/pages/dashboard/DashboardPage.jsx